import { create } from 'zustand';
import { v4 as uuid } from 'uuid';
import defaults from '../data/foods.json';
import { saveUtilityCache } from '../../../utils/utilityAppStorage';
import { NUTRIENTS, validateFood, validateRecipe, validateEntry } from '../utils/nutrition';
const empty = () => ({ foods: [], recipes: [], entries: [] });
const load = () => {
  try {
    const data = JSON.parse(localStorage.getItem('fitnessData') || '{}').nutrition || {};
    return { foods: data.foods || [], recipes: data.recipes || [], entries: data.entries || [] };
  } catch { return empty(); }
};
export const foodCatalog = overrides => {
  const merged = new Map(defaults.map(food => [food.id, food]));
  overrides.forEach(food => merged.set(food.id, food));
  return [...merged.values()].sort((a, b) => a.name.localeCompare(b.name, 'es'));
};
const upsert = (list, item) => list.some(row => row.id === item.id) ? list.map(row => row.id === item.id ? item : row) : [...list, item];
export const useNutritionStore = create((set, get) => {
  const commit = updates => {
    const current = get();
    const nutrition = { foods: current.foods, recipes: current.recipes, entries: current.entries, ...updates };
    const data = JSON.parse(localStorage.getItem('fitnessData') || '{}');
    saveUtilityCache('fitnessData', { ...data, nutrition });
    set(nutrition);
  };
  return {
    ...load(),
    saveFood: food => {
      validateFood(food);
      const row = { ...food, id: food.id || uuid(), name: food.name.trim(),
        nutrients: Object.fromEntries(NUTRIENTS.map(({ key }) => [key, [null, '', undefined].includes(food.nutrients[key]) ? null : Number(food.nutrients[key])])),
        portions: food.portions.map(p => ({ ...p, amount: Number(p.amount) })) };
      commit({ foods: upsert(get().foods, row) });
      return row;
    },
    saveRecipe: recipe => {
      validateRecipe(recipe);
      const row = { ...recipe, id: recipe.id || uuid(), name: recipe.name.trim(), servings: Number(recipe.servings), finalWeight: recipe.finalWeight === '' ? null : Number(recipe.finalWeight) || null };
      commit({ recipes: upsert(get().recipes, row) });
      return row;
    },
    saveEntry: entry => {
      validateEntry(entry);
      const row = { ...entry, id: entry.id || uuid() };
      commit({ entries: upsert(get().entries, row) });
    },
    deleteEntry: id => commit({ entries: get().entries.filter(row => row.id !== id) }),
    deleteRecipe: id => commit({ recipes: get().recipes.filter(row => row.id !== id) }),
  };
});
export const rehydrateNutrition = () => useNutritionStore.setState(load());
